import { useEffect, useState } from 'react';
import Particles, { initParticlesEngine } from '@tsparticles/react';
import { loadSlim } from '@tsparticles/slim';

const HeroParticles = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => setReady(true));
  }, []);

  if (!ready) return null;

  return (
    <Particles
      id="hero-particles"
      className="absolute inset-0"
      options={{
        fullScreen: false,
        background: {
          color: { value: 'transparent' },
        },
        fpsLimit: 60,
        particles: {
          color: { value: '#c7d2fe' },
          links: {
            enable: true,
            color: '#c7d2fe',
            opacity: 0.35,
            distance: 180,
            width: 1.2,
          },
          move: {
            enable: true,
            speed: 0.7,
            direction: 'none',
            outModes: { default: 'bounce' },
          },
          number: {
            value: 70,
            density: {
              enable: true,
              width: 1200,
              height: 800,
            },
          },
          opacity: {
            value: { min: 0.3, max: 0.7 },
          },
          size: {
            value: { min: 1.5, max: 4 },
          },
        },
        interactivity: {
          events: {
            onHover: {
              enable: true,
              mode: 'grab',
            },
          },
          modes: {
            grab: {
              distance: 180,
              links: {
                opacity: 0.3,
              },
            },
          },
        },
        detectRetina: true,
      }}
    />
  );
};

export default HeroParticles;
